function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import find from './find';

function on(selector, event, cb, options) {
  if (Array.isArray(selector)) {
    selector.forEach(function (item) {
      return on(item, event, cb, options);
    });
    return;
  }

  var eventOptions = {};

  if (typeof options === 'boolean') {
    eventOptions.capture = options;
  } else if (_typeof(options) === 'object') {
    eventOptions = Object.assign({}, options);
  }

  var data = {
    cb: cb,
    options: eventOptions
  }; // _domassistevents keeps track of events we registered
  // with 'domassist.on' so they can be deregistered by
  // 'domassist.off' without affecting events registered
  // by other libraries:

  if (!window._domassistevents) {
    window._domassistevents = {};
  }

  window._domassistevents["_".concat(event)] = data;
  var el = find(selector);

  if (el.length) {
    el.forEach(function (item) {
      item.addEventListener(event, cb, eventOptions);
    });
  }
}

export default on;